import {
  FiltersCard,
  FiltersTitle,
  FiltersRow,
  FiltersActions,
  ApplyFiltersButton,
  ClearAllButton,
} from "./styles.tableWithFilters";

/** Generic "Filters" card: pass the filter fields as children. */
export default function FiltersPanel({ children, onApply, onClear, applyDisabled = false }) {
  return (
    <FiltersCard>
      <FiltersTitle>Filters</FiltersTitle>
      <FiltersRow>{children}</FiltersRow>
      <FiltersActions>
        <ApplyFiltersButton type="button" onClick={onApply} disabled={applyDisabled}>
          Apply filters
        </ApplyFiltersButton>
        <ClearAllButton type="button" onClick={onClear}>
          Clear all
        </ClearAllButton>
      </FiltersActions>
    </FiltersCard>
  );
}
